
import { createSlice } from '@reduxjs/toolkit';
import {
  fetchReferralHistoryItems,
  addReferralHistory,
} from './ReferralHistoryThunk.js'; // adjust path as needed

const referralHistorySlice = createSlice({
  name: 'referralHistory',
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReferralHistoryItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReferralHistoryItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchReferralHistoryItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addReferralHistory.fulfilled, (state, action) => {
        state.items.push(action.payload); // optional if you want to update local state
      });
  },
});

export default referralHistorySlice.reducer;
